import React, { Component } from "react";
import { StaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";
import PropTypes from "prop-types";

import "../css/homeBanner.css";
import "../css/globalRules.less";

const BannerImage = (props) => {
  return (
    <StaticQuery
      query={graphql`
        query {
          taigun: file(
            relativePath: { eq: "desktop-banner/taigun/taigun-desktop.jpg" }
          ) {
            childImageSharp {
              fluid(maxWidth: 1500) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          mobtaigun: file(
            relativePath: { eq: "mobile-banner/taigun/taigun-mobile.png" }
          ) {
            childImageSharp {
              fluid(maxWidth: 800) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          virtus: file(
            relativePath: { eq: "desktop-banner/virtus/virtus-desktop.jpg" }
          ) {
            childImageSharp {
              fluid(maxWidth: 1500) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          mobvirtus: file(
            relativePath: { eq: "mobile-banner/virtus/virtus-mobile.png" }
          ) {
            childImageSharp {
              fluid(maxWidth: 800) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          tiguan: file(
            relativePath: { eq: "desktop-banner/tiguan/tiguan-desktop.jpg" }
          ) {
            childImageSharp {
              fluid(maxWidth: 1500) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          mobtiguan: file(
            relativePath: { eq: "mobile-banner/tiguan/tiguan-mobile.png" }
          ) {
            childImageSharp {
              fluid(maxWidth: 800) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      `}

      render={(data) => {
        let imagesObject = {};
        Object.keys(data).forEach((key) => {
          const imageBase64Data = [
            {
              ...data[key]?.childImageSharp.fluid,
              media: `(min-width: 768px)`,
            },
            data["mob" + key]?.childImageSharp.fluid,
          ];
          if (!key.startsWith("mob", 0)) {
            imagesObject[key] = imageBase64Data;
          }
        });

        return <Img fluid={imagesObject[props.banner]} alt="Image" />;
      }}
    />
  );
};

BannerImage.propTypes = {
  banner: PropTypes.string.isRequired,
};

export default class HomeBanner extends Component {
  render() {
    const carSelection = (value) => {
      return (
        <>
          <BannerImage banner={value} />
        </>
      );
    };

    return (
      <div className="homebanner container-fluid px-0">
        <div id="banner" className="carousel slide" data-bs-ride="carousel">
          <div className="carousel-inner">
            <div className="carousel-item active">
              {carSelection(this.props.carName)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
